import mdl from '@/models/Accounting/AccCostCenter'

const createCostCenter = async data => {
    let seat = new mdl(data)
    try {
        let response = await seat.save()
        return response
    } catch (error) {
        return error.response
    }
}

export { createCostCenter }
